import Vue from 'vue'
import Router from 'vue-router'

// Client
import Base from '@/components/Base.vue'
import Home from '@/components/Home.vue'
import VideoArchives from '@/components/VideoArchives'
import VideoPlayer from '@/components/VideoPlayer.vue'
import Thisism from '@/components/Thisism.vue'
import More from '@/components/More.vue'

Vue.use(Router)

const routes = [
  {
    path: '/',
    component: Base,
    children: [
      {
        path: '', component: Home, name: 'home'
      },
      {
        path: 'video-archives', component: VideoArchives, name: 'video-archives'
      },
      {
        path: 'player/:ytid', component: VideoPlayer, name: 'video-player'
      },
      {
        path: 'thisism', component: Thisism, name: 'thisism'
      },
      {
        path: 'more', component: More, name: 'more'
      }
    ]
  }
]

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return {x: 0, y: 0}
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js